import React from 'react';
import Header from "../partials/Header";

function HomeUser() {
    return (
        <div className="flex flex-col min-h-screen overflow-hidden">

            {/*  Site header */}
            <Header />
        </div>
    );
}

export default HomeUser;
